import { connect } from 'react-redux';
import { logout } from '../actions/auth';
import AppBarUserProfile from '../components/app_bar_user_profile/app_bar_user_profile';

function mapStateToProps({ auth }) {
  return {
    user: auth.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppBarUserProfile);



// WEBPACK FOOTER //
// ./src/containers/app_bar_user_profile.js